(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSCambiarFechasConfirmacionController',SSCambiarFechasConfirmacionController);

    SSCambiarFechasConfirmacionController.$inject = ['$uibModalInstance', '$state', 'entity'];

    function SSCambiarFechasConfirmacionController($uibModalInstance, $state, entity) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDateChange = confirmDateChange;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDateChange (id) {
            $uibModalInstance.close(true);
		}
    }
})();
